import { ArrowLeft } from "lucide-react";
import Stepper from "./Stepper";

export default function WizardShell({
  backLabel,
  onBack,
  steps,
  currentStep,
  onStepChange,
  canGoToStep,
  summary,
  footer,
  children,
}) {
  return (
    <div className="flex flex-col gap-6">
      <div className="flex flex-wrap items-center justify-between gap-4">
        {onBack ? (
          <button
            type="button"
            onClick={onBack}
            className="inline-flex h-10 items-center gap-2 rounded-(--radius-md) border border-(--border-subtle) bg-(--surface-1) px-4 text-sm font-medium text-(--text-primary) hover:bg-(--surface-2)"
          >
            <ArrowLeft size={16} strokeWidth={2} />
            {backLabel ?? "Back"}
          </button>
        ) : (
          <span />
        )}
        <Stepper
          steps={steps}
          currentStep={currentStep}
          onStepChange={onStepChange}
          canGoToStep={canGoToStep}
        />
      </div>

      <div
        className={`grid items-start gap-6 ${
          summary ? "lg:grid-cols-[1fr_320px]" : ""
        }`}
      >
        <div className="flex min-w-0 flex-col gap-6">
          {children}
          {footer && (
            <div className="flex items-center justify-between gap-3">
              {footer}
            </div>
          )}
        </div>
        {summary && (
          <aside className="lg:sticky lg:top-6 flex flex-col gap-4">
            {summary}
          </aside>
        )}
      </div>
    </div>
  );
}
